import { SET_TV_SETTINGS } from '../types/tvSettings'
import { getTvSettingsAPI, saveTvSettingsAPI } from '../api/tvSettings'
import { addMessageCurry } from '../utils/api'

export const setTvSettings = (payload) => ({
  type: SET_TV_SETTINGS,
  payload: payload,
})

export const getTvSettings = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getTvSettingsAPI(), dispatch)
        .then((tvSettings) => {
          resolve(tvSettings)
          dispatch(setTvSettings({ tvSettings }))
        })
        .catch((err) => console.log(err))
    })
  }
}

export const saveTvSettings = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(saveTvSettingsAPI(data), dispatch)
        .then((tvSettings) => {
          resolve(tvSettings)
          dispatch(setTvSettings({ tvSettings }))
        })
        .catch((err) => console.log(err))
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/tvSettings.js